import React from 'react';
import { useLanguage } from '../LanguageContext';

export const ThankYouMessage: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <div className="thank-you-message">
      {t('thankYouMessage')}
    </div>
  );
}; 